<section #sectionRef id="testimonials" class="section-padding bg-white relative overflow-hidden">
  <!-- Decorative Circles -->
  <div class="absolute top-0 right-0 w-64 h-64 bg-lavender/20 rounded-full translate-x-1/2 -translate-y-1/2"></div>
  <div class="absolute bottom-0 left-0 w-48 h-48 bg-peach/10 rounded-full -translate-x-1/3 translate-y-1/3"></div>

  <div class="container mx-auto px-4 md:px-6 relative z-10">
    <div class="max-w-xl mx-auto text-center mb-16 appear-on-scroll opacity-0">
      <span class="subtitle mb-3">Customer Stories</span>
      <h2 class="heading-lg mb-5">What Our Community Says</h2>
      <p class="body-md text-forest/80">
        Real experiences from real people who have incorporated our products into their wellness journey.
      </p>
    </div>

    <div class="max-w-4xl mx-auto" >
      <div class="appear-on-scroll opacity-0 relative">
        <div class="glass-card rounded-2xl p-6 md:p-10 shadow-md">
          <div class="flex flex-col md:flex-row gap-8 items-start">
            <!-- User Image and Info -->
            <div class="flex-shrink-0 md:w-1/3">
              <div class="aspect-square w-20 h-20 md:w-28 md:h-28 rounded-full overflow-hidden border-4 border-mint/30 mx-auto md:mx-0">
                <img
                  [src]="testimonials[activeIndex].image"
                  [alt]="testimonials[activeIndex].name"
                  class="w-full h-full object-cover"
                />
              </div>
              <div class="mt-4 text-center md:text-left">
                <h3 class="font-cormorant text-xl font-semibold">{{ testimonials[activeIndex].name }}</h3>
                <!-- <p class="text-forest/70 text-sm">{{ testimonials[activeIndex].subtitle }}</p> -->
                <div class="flex items-center justify-center md:justify-start mt-2 space-x-1">
                  <ng-container *ngFor="let star of getStars(testimonials[activeIndex].stars); let i = index">
                    <svg
                      [ngClass]="star ? 'text-yellow-500' : 'text-gray-300'"
                      class="h-4 w-4 fill-current"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24">
                      <path d="M12 .587l3.668 7.431L24 9.75l-6 5.849L19.335 24 12 20.202 4.665 24 6 15.599 0 9.75l8.332-1.732z"/>
                    </svg>
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- Testimonial Content -->
            <div class="md:w-2/3">
              <blockquote class="text-forest relative">
                <span class="font-cormorant text-6xl text-mint absolute -top-8 left-0">"</span>
                <p class="pl-6 pt-2 italic">{{ testimonials[activeIndex].testimonial }}</p>
              </blockquote>
            </div>
          </div>
        </div>

        <!-- Navigation Arrows -->
        <div class="flex justify-center md:justify-end space-x-3 mt-6">
          <button
            (click)="handlePrev()"
            class="p-3 rounded-full border border-mint/30 text-forest hover:bg-mint/20 transition-colors duration-200"
            aria-label="Previous testimonial">
            <!-- Left Arrow -->
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M15 18l-6-6 6-6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
          </button>

          <button
            (click)="handleNext()"
            class="p-3 rounded-full border border-mint/30 text-forest hover:bg-mint/20 transition-colors duration-200"
            aria-label="Next testimonial">
            <!-- Right Arrow -->
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M9 18l6-6-6-6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
